import { useQuery } from "@tanstack/react-query";
import { loadPlanning, type PlanningPeriod } from "./api";

// One snapshot per book and month for the whole planning page.
export function usePlanning(bookID: string | undefined, period: PlanningPeriod) {
  return useQuery({
    queryKey: ["planning", bookID, period.key],
    queryFn: () => loadPlanning(bookID!, period),
    enabled: Boolean(bookID),
  });
}
